//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockInventoryRegradingRecords from './StockInventoryRegradingRecords.vue'

export default {
  components: {
    StockInventoryRegradingRecords
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: null
    },
    additionalAccessAdd: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    regradingRecords: {
      type: Array,
      default: null
    },
    toolRecords: {
      type: Array,
      default: null
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    onClear: function () {
      const refRegradingRecords = this.$refs.regradingRecords
      if (refRegradingRecords) {
        refRegradingRecords.filteredRegradingRecords.forEach(r => {
          refRegradingRecords.onDelete(r)
        })
      }
    }
  }
}

